import RProvider from './provider.routes'
import RPartner from './partner.routes'
import RClient from './client.routes'
import RShared from './shared.routes'

const allRoutes = []

export default allRoutes.concat(
  RProvider,
  RShared,
  RClient,
  RPartner
)
